import { push } from 'connected-react-router'
import {
  checkHttpStatus,
  getApiBaseUrlWithOrg,
  getApiHeaders
} from '../utils/api'

export function postLevelTargetDate(courseSectionId, levelId, date) {
  return async (dispatch, getState) => {
    const state = getState()

    try {
      checkHttpStatus(
        await fetch(
          `${getApiBaseUrlWithOrg(
            state.organization.orgId
          )}/mentor/course_sections/${courseSectionId}/levels/${levelId}/mentor_target`,
          {
            method: 'PUT',
            headers: getApiHeaders(state),
            body: JSON.stringify({
              mentor_target_on: date
            })
          }
        )
      )
    } catch (error) {
      if (error.response.status === 404) {
        dispatch(push('/notfound'))
      }

      if (error.response.status === 500) {
        dispatch(push('/error'))
      }
    }
  }
}
